import React from 'react';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const SignOutPage = () => {

  const {t} = useTranslation()
  const history = useHistory();

  const onSubmit = (e) => {
    e.preventDefault();
    let button = e.currentTarget;
    if (button.clicked) {
      return
    }
    button.clicked = true

    var cognitoUser = window.userPool.getCurrentUser()

    cognitoUser.signOut()
    window.location = "/user/login"
  }

  document.title = t("titleappname") + t("title_signout")

  return <div className="wrap-login100">
    <form className="login100-form validate-form" onSubmit={onSubmit}>
      <h3>{t("title_signout")}</h3>

      <div>
        <button className="submit-btn-2">{t("btn_signout")}</button>
      </div>
    </form>
  </div>

}

export default SignOutPage
